<template>
    <div>
        <div style="width:100%;background: #fff;">
        <div class="handle_wrapper">
            <div class="handle clearfix">
                <div class="logo"><a href="/" class="logo_link"><img
                            src="https://wimage.jxrsrc.com/2022-04-11-6253d5890731b.jpeg" class="handLe_img"
                            lazysrc="finish"></a></div>
                <div class="right_btn">
                    <div class="handle_search mid_nav clearfix">
                        <div class="nav_li"><a href="https://service.jxrsrc.com:8081/#/talentspolicy"
                                target="_blank">人才政策</a></div>
                        <div class="nav_li"><a href="https://service.jxrsrc.com:8081/#/" target="_blank">人才认定</a></div>
                        <div class="nav_li"><a href="https://service.jxrsrc.com:8081/#/talentsproject"
                                target="_blank">人才工程</a></div>
                        <div class="nav_li"><a href="https://service.jxrsrc.com:8081/#/TalentsEvents"
                                target="_blank">人才活动</a></div>
                        <div class="nav_li"><a href="https://service.jxrsrc.com:8081/#/talentservice"
                                target="_blank">人才服务</a></div>
                        <div class="nav_li"><a href="https://dlo.jxrsrc.com/P_Detail/Index2.aspx" target="_blank">人才派遣</a>
                        </div>
                        <div class="nav_li"><a href="http://www.jxrcgy.net/Default.aspx" target="_blank">人才公寓</a></div>
                        <div class="nav_li"><a href="http://jxqqx.nhyouth.gov.cn/News_View.asp?AID=392"
                                target="_blank">人才驿站</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav_wrapper">
            <ul class="nav clearfix">
                <li class="nav_item"><a href="https://www.jxrsrc.com/" class="item">网站首页</a></li>
                <li class="nav_item "><a href="https://www.jxrsrc.com/outjobfair" target="_self" class="item">
                        外出招聘 </a></li>
                <li class="nav_item "><a href="https://xczph.jxrsrc.com:7777/web/#/OnSiteJobfair" target="_blank"
                        class="item">
                        市场招聘 </a></li>
                <li class="nav_item "><a href="https://www.jxrsrc.com/article/cid/27" target="_self" class="item">
                        网络招聘 </a></li>
                <li class="nav_item "><a href="http://www.jxrsrc.com/famouscom/list/oversealist.html" target="_self"
                        class="item">
                        海外招聘 </a></li>
                <li class="nav_item "><a href="https://ac.jxrsrc.com/leadingtalents/index" target="_blank" class="item">
                        领军企业 </a></li>
                <li class="nav_item "><a href="http://zy.jxkp.net/" target="_blank" class="item">
                        成长学院 </a></li>
                <li class="nav_item "><a href="http://www.jxrsrc.com/famouscom/list/jxunionlist.html" target="_self"
                        class="item">
                        嘉兴联盟 </a></li>
            </ul>
        </div>
    </div>
        <div style="width: 100%;margin: 0 auto;background-color: #f1f8fe;text-align: center;"><img class="mobile_img"
                :src="banner" alt="" style="margin: 0 auto;width: 1200px;" /></div>
    </div>
</template> 
    
<script>
// import Vue from "vue";
// import "@/icons/iconfont.js";
import banner from "@/assets/banner6.png";
export default {
    name: "mheader",
    components: {},
    data() {
        return {
            banner
        };
    },
    created() {

    },
    mounted() { },
    methods: {},
};
</script>
    
<style scoped>
.handle {
    width: 1200px;
    margin: auto;
    height: 91px;
    position: relative;
    background: #fff;
}

.clearfix:after,
.clearfix:before {
    content: "";
    display: table;
}

.handle .logo {
    float: left;
    width: 280px;
    height: 91px;
    line-height: 91px;
    overflow: hidden;
}

.handle .logo .logo_link {
    display: block;
    position: relative;
}

.handle .logo .logo_link::before {
    content: "";
    position: absolute;
    left: -10px;
    top: -460px;
    width: 200px;
    height: 10px;
    background-color: rgba(255, 255, 255, 0.5);
    transform: rotate(-45deg);
    animation: searchLights 1.5s ease-in 1s infinite;
}
.nav_wrapper .nav .nav_item:hover {
    background-color: #FF9702;
}
.handle .handLe_img {
    max-width: 220px;
    max-height: 90px;
    vertical-align: middle;
}

.handle .right_btn {
    float: right;
}
.handle .mid_nav {
    width: 424px;
    height: 62px;
    font-size: 15px;
    margin: 12px 0 0 300px;
}
.handle .nav_li {
    float: left;
    width: 100px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    border-radius: 18px;
    margin-top: 3px;
    margin-right: 5px;
    border: 1px solid #ff772d;
    color: #ff772d;
}
.handle .nav_li a {
    color: #ff772d;
}
.handle .handle_search {
    float: left;
}
.clearfix:after {
    clear: both;
}

.clearfix:after,
.clearfix:before {
    content: "";
    display: table;
}
.nav_wrapper .nav {
    width: 1200px;
    margin: auto;
    background-image: linear-gradient(#FF0001, #FF9703);
}
.clearfix:after, .clearfix:before {
    content: "";
    display: table;
}
.nav_wrapper .nav .nav_item {
    float: left;
    font-size: 16px;
    position: relative;
    cursor: pointer;
}
.nav_wrapper .nav .nav_item .item {
    display: block;
    padding: 8px 45px;
    margin-bottom: 0;
    color: #ffffff;
    font-size: 15px;
    font-weight: bold;
    text-decoration: none;
}
.clearfix:after {
    clear: both;
}

.clearfix:after, .clearfix:before {
    content: "";
    display: table;
}
</style>
    